<template>
  <section class="bg-sipsBlack ">
    <div class="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
      <div class="mx-auto max-w-3xl text-center">
        <h2 class="mb-10 text-3xl tracking-tight font-extrabold leading-tight text-white " v-html="title">
        </h2>


        <button
            @click="scrollTo(goToSectionId)"
            class="inline-flex items-center justify-center px-10 uppercase inline-block text-sm lg:text-lg hover:shadow-lg text-center font-ginger leading-4 bg-lifeboost-red text-white hover:opacity-80 rounded-full py-3.5 xl:py-4 px-7 xl:px-9 transition-all" v-html="buttonText">
        </button>



      </div>
    </div>
  </section>
</template>

<script setup>


defineProps({
  title: {
    type: String,
    default: 'As the new season unfolds, indulge in an incredible coffee experience with each exquisite blend thoughtfully shipped to your doorstep.',
  },
  buttonText: {
    type: String,
    default: 'Start your Seasonal Sips Club',
  },
  goToSectionId: {
    type: String,
    default: 'the-products',
  }

})

defineBuilderComponent({
    friendlyName: "SeasonalSipsClub",
    canHaveChildren: true,
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "As the new season unfolds, indulge in an incredible coffee experience with each exquisite blend thoughtfully shipped to your doorstep."
        },
        {
            name: "buttonText",
            type: "richText",
            defaultValue: "Start your Seasonal Sips Club"
        },
        {
            name: "goToSectionId",
            type: "text",
            defaultValue: "the-products"
        }
    ]
});
</script>